import React from 'react';
import './MusicPage.css';

const albums = [
  {
    title: 'Byron Schmyron',
    year: 2026,
    image: '/Byron_Schmyron.png',
    isLimited: false,
    flash: true,
    streamingLinks: [
      { platform: 'Spotify', url: 'https://open.spotify.com/album/0TirZ3EBfFnhIrPQwFVSNN?si=OJTFn1AKTe-8gIsU-BSB-A' },
      { platform: 'AppleMusic', url: 'https://music.apple.com/us/artist/d-byron/1700392730' },
      { platform: 'YouTube', url: 'https://www.youtube.com/watch?v=uQ-RdJhZs7g&list=OLAK5uy_k9pGZyJv1JJLnS4v8pXAm2GRksUCP7HOM' },
      { platform: 'Pandora', url: 'https://www.pandora.com/artist/d-byron/byron-schmyron/ALnm9vdkzph22PJ' },
      { platform: 'iHeart', url: 'https://www.iheart.com/artist/d-byron-40939167/albums/byron-schmyron-369425584' }
    ]
  },
  {
    title: 'A Muse Made Me Do It',
    year: 2025,
    image: '/muse.png',
    isLimited: false,
    flash: false,
    streamingLinks: [
      { platform: 'Spotify', url: 'https://open.spotify.com/artist/3RYb0Sn2fzlMVTnES9xtGp' },
      { platform: 'AppleMusic', url: 'https://music.apple.com/us/artist/d-byron/1700392730' },
      { platform: 'YouTube', url: 'https://www.youtube.com/@DByronMusician' },
      { platform: 'Pandora', url: 'https://www.pandora.com/artist/d-byron/ARxtvlrkb3Vd4pP' },
      { platform: 'iHeart', url: 'https://www.iheart.com/artist/d-byron-40939167/' }
    ]
  },
  {
    title: 'File Under Unheard',
    year: 2024,
    image: '/fileunderunheard.png',
    isLimited: false,
    flash: false,
    streamingLinks: [
      { platform: 'Spotify', url: 'https://open.spotify.com/album/4l9OhH1Fu25MvNcaZqkTXz' },
      { platform: 'AppleMusic', url: 'https://music.apple.com/us/album/file-under-unheard/1778154896' },
      { platform: 'YouTube', url: 'https://www.youtube.com/playlist?list=OLAK5uy_lHG668dgILBt3Ee5KOw-TpNo9VA98E6VE' },
      { platform: 'Pandora', url: 'https://www.pandora.com/artist/d-byron/file-under-unheard/ALbKxmdzJpvVPVm' }
    ]
  },
  {
    title: 'Selling Sounds on Planet Deaf',
    year: 2002,
    image: '/sellingsoundsonplanetdeaf.png',
    isLimited: false,
    flash: false,
    streamingLinks: [
      { platform: 'Spotify', url: 'https://open.spotify.com/album/6vwOQrIhJb6AO0PxbnzC7E' },
      { platform: 'AppleMusic', url: 'https://music.apple.com/us/album/selling-sounds-on-planet-deaf/1700393589' },
      { platform: 'YouTube', url: 'https://www.youtube.com/playlist?list=OLAK5uy_nJl52qDYfMAAfvXm3gyzC83eioXJ6BL-s' },
      { platform: 'Pandora', url: 'https://www.pandora.com/artist/d-byron/selling-sounds-on-planet-deaf/ALhdlmj4tbx6Kk2' }
    ]
  },
  {
    title: 'The Antmen of Neopop',
    year: 1996,
    image: '/antmen cover art.png',
    isLimited: false, // Technically vinyl purchase, handle similarly
    flash: true,
    streamingLinks: [
      { platform: 'Spotify', url: 'https://open.spotify.com/artist/0xnXLSvovC2JMcPyttSR2R' },
      { platform: 'AppleMusic', url: 'https://music.apple.com/us/artist/the-antmen-of-neopop/1679718833' },
      { platform: 'YouTube', url: 'https://www.youtube.com/channel/UChqZUh_ua86CMHTmRqLI73A' },
      { platform: 'Pandora', url: 'https://www.pandora.com/artist/the-antmen-of-neopop/the-antmen-of-neopop/ALk2hjc4VprnV4J' }
    ]
  }
];

// Helper function to get CSS class for platform
const getPlatformClass = (platform) => {
  return platform.toLowerCase().replace(' ', '-');
};

function MusicPage() {
  return (
    <div className="music-page">
      <h1>Music</h1>
      <div className="album-list">
        {albums.map((album, index) => (
          <div key={index} className="album-entry">
            <div className="album-cover">
              <img src={album.image} alt={`${album.title} Cover`} />
            </div>
            <div className="album-info">
              <h2>{album.title} ({album.year})</h2>
              {album.releaseNote && (
                <div className="purchase-link">
                  <button className={`btn ${album.flash ? 'flash-button' : ''}`} disabled>
                    {album.releaseNote}
                  </button>
                </div>
              )}
              {album.purchaseLink && (
                <div className="purchase-link">
                  <a
                    href={album.purchaseLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`btn elastic-stage ${album.flash ? 'flash-button' : ''}`}
                  >
                    {album.purchaseText}
                  </a>
                </div>
              )}
              {album.streamingLinks.length > 0 && (
                <div className="streaming-links">
                  {album.streamingLinks.map((link, linkIndex) => (
                    <a
                      key={linkIndex}
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`btn ${getPlatformClass(link.platform)}`}
                    >
                      {link.platform}
                    </a>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      <section className="artist-statement">
        <h2>Artist Statement - D Byron</h2>
        <p>I write songs from images and ideas rather than explanations. The meaning is rarely stated directly -- it is something listeners uncover for themselves. My work often begins with a simple image, story, or philosophical question that gradually transforms into something emotional and symbolic. The literal source may remain hidden, but the feeling behind it is what matters.</p>
        <p>Across my albums -- Selling Sounds on Planet Death, File Under Forgotten, A Muse Made Me Do It, and Byron Schmyron -- I explore themes of identity, awareness, alienation, inspiration, and the tension between meaning and recognition. Many songs draw from mythology, philosophy, and literature, not as academic references but as emotional metaphors. Figures like Icarus, Plato's cave, Kafka's characters, and Dostoevsky's Underground Man appear in the work as ways of thinking about ambition, awakening, isolation, and what it means to become conscious of one's place in the world.</p>
        <p>Some songs are explicit in their references, while others conceal their origins entirely. A song may emerge from something concrete -- a story, an image, or even a fleeting moment -- and evolve into something abstract and psychological. I am less interested in explaining what a song is "about" than in creating a space where listeners can encounter their own meaning within it.</p>
        <p>I'm drawn to an older understanding of art, where the value of creation lies primarily in the act of making rather than the finished product. The process of writing and recording is a form of exploration -- a way of thinking, questioning, and discovering. The albums are traces of that process, records of a particular moment of inquiry rather than definitive statements.</p>
        <p>Yet once the work exists, it becomes something that can be shared. Releasing music is not about presenting a final answer, but about extending the process outward -- allowing the work to continue through the interpretations and experiences of others.</p>
        <p>My music is released under my own name, not as a fixed persona, but simply as a record of ongoing reflection. Each project marks a different stage of questioning and growth, connected by a continuing interest in consciousness, perception, and the search for meaning.</p>
      </section>
    </div>
  );
}

export default MusicPage;
